/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function Nut(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M215.93555,73.70325l-84-47.47815a7.99926,7.99926,0,0,0-7.87305,0l-84,47.47815A8.00029,8.00029,0,0,0,35.999,80.66772v94.66456a8.00065,8.00065,0,0,0,4.06348,6.9646l84,47.47814a7.99987,7.99987,0,0,0,7.87305,0l84-47.47814a8.00064,8.00064,0,0,0,4.06347-6.9646V80.66772A8.00028,8.00028,0,0,0,215.93555,73.70325ZM127.999,164a36,36,0,1,1,36-36A35.99991,35.99991,0,0,1,127.999,164Z"
        opacity={0.2}
      />
      <Path
        d="M219.999,175.33228V80.66772a8,8,0,0,0-4.06354-6.9645l-84-47.47826a8,8,0,0,0-7.87291,0l-84,47.47826a8,8,0,0,0-4.06355,6.9645v94.66456a8,8,0,0,0,4.06355,6.96451l84,47.47826a8,8,0,0,0,7.87291,0l84-47.47826A8,8,0,0,0,219.999,175.33228Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Circle
        cx={127.99902}
        cy={128}
        r={36}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Nut;
